import { WebUrl } from "shared-web/lib/webUrl"

export function adminProfitAndLoss(): WebUrl {
  return {
    pathname: "/admin/reporting/profit-and-loss",
  }
}

export function adminBalanceSheet(): WebUrl {
  return {
    pathname: "/admin/reporting/balance-sheet",
  }
}

export function adminPurchaseJournal(): WebUrl {
  return {
    pathname: "/admin/reporting/purchase-journal",
  }
}

export function adminJournalEntries(): WebUrl {
  return {
    pathname: "/admin/reporting/journal-entries",
  }
}

export function adminPayouts(): WebUrl {
  return {
    pathname: "/admin/reporting/payoutsv2",
  }
}

export function adminGeneralLedgerReport(): WebUrl {
  return {
    pathname: "/admin/reporting/general-ledger",
  }
}

export function adminReportBuilderReport(identifier?: string): WebUrl {
  return {
    pathname: `/admin/reporting/build-report/report/${encodeURIComponent(identifier ?? "")}`,
    query: {
      identifier: identifier,
    },
  }
}
